import { REFERRAL, type ReferralsDto, itemById } from '@penalty-cup/shared';
import { useCallback, useEffect, useState } from 'react';
import { api } from '../api.js';
import { Jersey } from '../components/Jersey.js';
import { useApp } from '../store.js';
import { useBackButton } from '../telegram-back.js';
import { ShareButton } from './ShareButton.js';

/** Пригласи друзей: личная ссылка, кто пришёл и сколько сыграл, награды и рубежи. */
export function Referrals() {
  const token = useApp((s) => s.token);
  const share = useApp((s) => s.share);
  const setView = useApp((s) => s.setView);
  const back = useCallback(() => setView(null), [setView]);
  useBackButton(back);
  const [data, setData] = useState<ReferralsDto | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!token) return;
    let alive = true;
    api.referrals(token).then(
      (d) => alive && setData(d),
      () => undefined,
    );
    return () => {
      alive = false;
    };
  }, [token]);

  const copy = async () => {
    if (!data?.link) return;
    try {
      await navigator.clipboard.writeText(data.link);
      setCopied(true);
    } catch {
      window.prompt('Ваша ссылка', data.link);
    }
  };

  return (
    <main className="screen referrals screen--nav">
      <div className="ticket-modal__icon" aria-hidden="true">
        🎁
      </div>
      <h1 className="screen__title">Пригласи друзей</h1>
      <div className="ref__rules">
        <p>
          Друг сыграет {REFERRAL.matches} матча — тебе{' '}
          <b>
            +{REFERRAL.inviter.tickets} 🎟 и +{REFERRAL.inviter.coins} 🪙
          </b>
          , ему{' '}
          <b>
            +{REFERRAL.invitee.tickets} 🎟 и +{REFERRAL.invitee.coins} 🪙
          </b>
        </p>
      </div>
      <ShareButton label="📨 Пригласить в Telegram" onShare={() => share({ kind: 'referral' })} />
      <button type="button" className="link" onClick={() => void copy()} disabled={!data?.link}>
        {copied ? 'Ссылка скопирована' : 'Скопировать ссылку'}
      </button>
      {data && (
        <>
          <div className="ref__summary">
            <div className="stat">
              <b>{data.qualified}</b>
              <span>засчитано</span>
            </div>
            <div className="stat">
              <b>+{data.earned.tickets} 🎟</b>
              <span>получено</span>
            </div>
            <div className="stat">
              <b>+{data.earned.coins} 🪙</b>
              <span>получено</span>
            </div>
          </div>
          <ul className="ref__milestones">
            {data.milestones.map((m) => (
              <li key={m.count} className={m.reached ? 'ref__milestone--on' : ''}>
                {m.reached ? '✅' : '🔒'} {m.count} друзей — «{itemById(m.itemId)?.name}»
                {m.reached ? ' (в магазине)' : ''}
              </li>
            ))}
          </ul>
          {data.friends.length === 0 ? (
            <p className="field__hint">Пока никто не пришёл по вашей ссылке</p>
          ) : (
            <ul className="friends__list">
              {data.friends.map((f, i) => (
                <li key={i} className="friends__row">
                  <Jersey kit={f.kit} className="friends__kit" />
                  <span className="friends__name">
                    {f.name}
                    <small className={f.qualified ? 'friends__online' : ''}>
                      {f.qualified ? 'засчитан ✓' : `сыграл ${f.matches} из ${REFERRAL.matches}`}
                    </small>
                  </span>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </main>
  );
}
